export const BALLERS_COMMUNITY_ID = '5a0c2419-53be-44e5-9da6-079211983292';
export const TIER2_COMMUNITY_ID = 'fcb5d307-9485-4118-a805-6125c3e04812';
export const TIER3_COMMUNITY_ID = '315c012d-7030-43d1-bd70-2dccff0ade6e';
export const TIER4_COMMUNITY_ID = '517e45d3-7a0d-4f7a-a66b-62e89918ad9d';
export const TIER5_COMMUNITY_ID = '8837d348-e1e4-4cca-b8c1-932ab7962c4a';
export const TEST_CREDIT_COMMUNITY_ID = '48d065cd-43c2-4ec7-ad95-b9a348c6cff9';

const COMMUNITY_PACKAGES = [
  { id: 'game_1', credits: 1, price: 37.5, perGame: 37.5, label: 'Single Match', popular: false, savings: null },
  { id: 'game_10', credits: 10, price: 300, perGame: 30, label: 'Pro Pack', popular: false, savings: null },
];

/** First-game price on the upload checkout. Buy credits uses COMMUNITY_PACKAGES. */
const UPLOAD_PACKAGES = [
  { id: 'game_1', credits: 1, price: 25, compareAt: 37.5, perGame: 37.5, label: 'Single Match', popular: false, savings: 33 },
  { id: 'game_10', credits: 10, price: 300, perGame: 30, label: 'Pro Pack', popular: false, savings: null },
];

const DISCOUNTED_PACKAGES = [
  { id: 'game_1', credits: 1, price: 25, perGame: 25, label: 'Single Match', popular: false, savings: null },
  { id: 'game_10', credits: 10, price: 180, perGame: 18, label: 'Pro Pack', popular: true, savings: 28 },
];

const TEST_PACKAGES = [
  { id: 'game_1', credits: 1, price: 1, perGame: 1, label: 'Single Match', popular: false, savings: null },
];

const TIER4_PACKAGES = [
  { id: 'game_1', credits: 1, price: 18, perGame: 18, label: 'Single Match', popular: false, savings: null },
  { id: 'game_10', credits: 10, price: 180, perGame: 18, label: 'Pro Pack', popular: true, savings: null },
];

const TIER5_PACKAGES = [
  { id: 'game_1', credits: 1, price: 12, perGame: 12, label: 'Single Match', popular: false, savings: null },
  { id: 'game_15', credits: 15, price: 150, perGame: 10, label: 'Pro Pack', popular: true, savings: 17 },
];

const PACKAGES_BY_TIER = {
  ballers: DISCOUNTED_PACKAGES,
  tier2: DISCOUNTED_PACKAGES,
  tier3: DISCOUNTED_PACKAGES,
  tier4: TIER4_PACKAGES,
  tier5: TIER5_PACKAGES,
  test: TEST_PACKAGES,
  default: COMMUNITY_PACKAGES,
};

export function getCommunityPricingTier(communityId) {
  if (communityId === TEST_CREDIT_COMMUNITY_ID) return 'test';
  if (communityId === BALLERS_COMMUNITY_ID) return 'ballers';
  if (communityId === TIER2_COMMUNITY_ID) return 'tier2';
  if (communityId === TIER3_COMMUNITY_ID) return 'tier3';
  if (communityId === TIER4_COMMUNITY_ID) return 'tier4';
  if (communityId === TIER5_COMMUNITY_ID) return 'tier5';
  return 'default';
}

export function getPackagesForCommunity(communityId) {
  const tier = getCommunityPricingTier(communityId);
  return PACKAGES_BY_TIER[tier];
}

/** Prices shown before a community exists. Checkout uses the community's own tier after that. */
export function getPublicGamePackages() {
  return UPLOAD_PACKAGES;
}

/** @deprecated Use getPackagesForCommunity and pass communityId to edge functions instead. */
export function getCybsFunctionName(baseName, communityId) {
  const tier = getCommunityPricingTier(communityId);
  if (tier === 'ballers') return baseName;
  if (tier === 'tier2') return `${baseName}-tier2`;
  return `${baseName}-copy`;
}
